import { render } from "./IconNdlOnline.vue?vue&type=template&id=226ceec6&scoped=true&ts=true"
import script from "./IconNdlOnline.vue?vue&type=script&lang=ts"
export * from "./IconNdlOnline.vue?vue&type=script&lang=ts"

import "./IconNdlOnline.vue?vue&type=style&index=0&id=226ceec6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226ceec6"]])

export default __exports__